import { render, staticRenderFns } from "./CollateralBankDetails.vue?vue&type=template&id=2e3bae5a&scoped=true&"
import script from "./CollateralBankDetails.vue?vue&type=script&lang=js&"
export * from "./CollateralBankDetails.vue?vue&type=script&lang=js&"
import style0 from "./CollateralBankDetails.vue?vue&type=style&index=0&lang=sass&"
import style1 from "../../../assets/collateral-compact-table.css?vue&type=style&index=1&id=2e3bae5a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e3bae5a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VDataTable,VIcon,VTextField})
